import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import Banner from "@tinqin/tinqin-ui-components/src/banner/Banner";
import Diaporama from "../../../slides/components/diaporama";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, SirenEntity } from "Common/utils/commonTypes";

export function buildChildren(entities: SirenEntity[] = []): JSX.Element[] {
    return entities.map((item: SirenEntity, index: number) => {
        const itemProps: Record<string, any> = item.properties || {};
        return (
            <Banner image={itemProps.src} key={index}>
                <h2 className="tq-panel-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(itemProps.title)
                        }}
                    />
                </h2>
                <h2 className="tq-panel-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(itemProps.text)
                        }}
                        data-hyperlinks-container={true}
                    />
                </h2>
            </Banner>
        );
    });
}

export const EmbeddedDiaporama: React.FC<IComponentProps> = props => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const entities: SirenEntity[] = props.data && props.data.entities;
    return (
        <div className="un-carousel-inner-wrapper" id={data.anchorId ? data.anchorId : null}>
            <Diaporama>{buildChildren(entities)}</Diaporama>
        </div>
    );
};

export default webui.connectComponent()(EmbeddedDiaporama);
